/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUnitsQuery } from '../../models/get-units-query';
import { GetUnitsQueryResult } from '../../models/get-units-query-result';

export interface ApiSettingsUnitsGetSettingsUnitsPost$Plain$Params {
      body?: GetUnitsQuery
}

export function apiSettingsUnitsGetSettingsUnitsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiSettingsUnitsGetSettingsUnitsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUnitsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiSettingsUnitsGetSettingsUnitsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUnitsQueryResult>;
    })
  );
}

apiSettingsUnitsGetSettingsUnitsPost$Plain.PATH = '/api/SettingsUnits/GetSettingsUnits';
